import type {
  AdminItemType,
  GetAdminListResponseType,
  LocationItemType,
  RoleItemType,
} from 'utils/apiList/admin'
import {
  SET_IS_START_ADMIN,
  SET_IS_FAILED_ADMIN,
  SET_IS_SUCCESS_ADMIN,
  SET_IS_NEED_TO_RELOAD_ADMIN,
  SET_PAGINATION_DATA_ADMIN,
  SET_LIST_LOCATION_WAREHOUSE,
  SET_LIST_LOCATION_HUB,
  SET_LIST_ROLES_WAREHOUSE,
  SET_LIST_ROLES_HUB,
  SET_LIST_OF_POSITION,
} from 'storeContext/actionsType/admin'

export interface AdminPaginationType {
  currentItem: number
  currentPage: number
  pageSize: number
  totalData: number
  totalPage: number
}

export interface AdminPositionType {
  name: string
}

export interface AdminStateType {
  isLoading: boolean
  adminData: AdminItemType[]
  paginationData: Partial<AdminPaginationType>
  needToReload: number
  listLocationOfWarehouse: LocationItemType[]
  listLocationOfHub: LocationItemType[]
  listRolesOfWarehouse: RoleItemType[]
  listRolesOfHub: RoleItemType[]
  listOfPosition: AdminPositionType[]
}

export type AdminActionType =
  | {
      type:
        | typeof SET_IS_START_ADMIN
        | typeof SET_IS_FAILED_ADMIN
        | typeof SET_IS_NEED_TO_RELOAD_ADMIN
      payload?: never
    }
  | { type: typeof SET_IS_SUCCESS_ADMIN; payload: GetAdminListResponseType }
  | { type: typeof SET_PAGINATION_DATA_ADMIN; payload: AdminPaginationType }
  | {
      type: typeof SET_LIST_LOCATION_WAREHOUSE | typeof SET_LIST_LOCATION_HUB
      payload: LocationItemType[]
    }
  | { type: typeof SET_LIST_ROLES_WAREHOUSE | typeof SET_LIST_ROLES_HUB; payload: RoleItemType[] }
  | { type: typeof SET_LIST_OF_POSITION; payload: AdminPositionType[] }

export const initialStateAdmin: AdminStateType = {
  isLoading: false,
  adminData: [],
  paginationData: {},
  needToReload: 1,
  listLocationOfWarehouse: [],
  listLocationOfHub: [],
  listRolesOfWarehouse: [],
  listRolesOfHub: [],
  listOfPosition: [],
}

export default function admin(
  state = initialStateAdmin,
  { type, payload }: AdminActionType,
): AdminStateType {
  switch (type) {
    case SET_IS_START_ADMIN:
      return {
        ...state,
        isLoading: true,
      }
    case SET_IS_FAILED_ADMIN:
      return {
        ...state,
        isLoading: false,
      }
    case SET_IS_SUCCESS_ADMIN:
      return {
        ...state,
        isLoading: false,
        adminData: payload.content,
      }
    case SET_IS_NEED_TO_RELOAD_ADMIN:
      return {
        ...state,
        needToReload: state.needToReload + 1,
      }
    case SET_PAGINATION_DATA_ADMIN:
      return {
        ...state,
        paginationData: payload,
      }
    case SET_LIST_LOCATION_WAREHOUSE:
      return {
        ...state,
        listLocationOfWarehouse: payload,
      }
    case SET_LIST_LOCATION_HUB:
      return {
        ...state,
        listLocationOfHub: payload,
      }
    case SET_LIST_ROLES_WAREHOUSE:
      return {
        ...state,
        listRolesOfWarehouse: payload,
      }
    case SET_LIST_ROLES_HUB:
      return {
        ...state,
        listRolesOfHub: payload,
      }
    case SET_LIST_OF_POSITION:
      return {
        ...state,
        listOfPosition: payload,
      }
    default:
      return {
        ...state,
      }
  }
}
